import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-vorlage-entfernen-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollVorlageEntfernenAdminEffects {

    FunkprotokollVorlageEntfernenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_VORLAGE_ENTFERNEN_ADMIN),
        mergeMap((x: ac.PostFunkprotokollVorlageEntfernenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollVorlageEntfernenAdmin(x.funkprotokollVorlageRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollVorlageEntfernenAdminErfolgreichAction(result, x.funkprotokollVorlageRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollVorlageEntfernenAdminFehlerAction(error, x.funkprotokollVorlageRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollVorlageCommandService);
        }
        return this.service;
    }
}
